import React, { useContext } from 'react';
import { Link } from '@reach/router';

import LogoutButton from '../../LogoutButton';
import { getAppTokenName, getUrl, APPS } from '@squirrellearningltd/go-shared-utils';
import { APP_NAME } from '../../../services/constants';
import ls from 'local-storage';
import { useApolloClient } from '@apollo/react-hooks';

import { AuthContext } from '../../../services/user/AuthProvider';
import cx from 'classnames';


const NavLinks = ({ onLogout, styles }) => {

    const client = useApolloClient();
    const { currentUser, setCurrentUser } = useContext(AuthContext); 
    const token = ls(getAppTokenName(APP_NAME));


    const goToPortal = (path) => {
        ls.clear();
        setCurrentUser(null);
        client.writeData({
            data: {
                loggedIn: false
            }
        });
        window.location.href = `${getUrl(APPS.go_portal_pupil)}`;
    }

    const goToPortalRewards = () => {
        ls.clear();
        setCurrentUser(null);
        client.writeData({
            data: {
                loggedIn: false
            }
        });
        window.location.href = `${getUrl(APPS.go_portal_pupil)}/rewards`;
    }

    const goToPortalBoomer = () => {
        ls.clear();
        setCurrentUser(null);
        client.writeData({
            data: {
                loggedIn: false
            }
        });
        window.location.href = `${getUrl(APPS.go_portal_pupil)}/boomer`;
    }

    return (
        <>
            <ul className={styles.menuNav}>
                <li><button onClick={() => goToPortal()} className={cx(styles.menuNavItem, styles.menuNavItemHome)}>Home</button></li>
                {currentUser.school?.canAccessBoomWriteApp && (
                    <li><a href={`${getUrl(APPS.go_write_pupil)}?token=${token}`} className={cx(styles.menuNavItem, styles.menuNavItemWrite)}>Write</a></li>
                )}
                <li><Link to='/' className={cx(styles.menuNavItem, styles.menuNavItemRead)}>Read</Link></li>
                <li>
                    <button onClick={() => goToPortalRewards()} className={cx(styles.menuNavItem, styles.menuNavItemRewards)}>Rewards</button>
                </li>
                {currentUser.boomerAvatarUrl ?
                    <li><button onClick={() => goToPortalBoomer()} className={cx(styles.menuNavItem, styles.menuNavItemBoomer)} style={{ backgroundImage: `url(${currentUser.boomerAvatarUrl}?v=${currentUser.updatedAt.replace(/\s/g, '')}` }}>Boomer</button></li> :
                    <li><button onClick={() => goToPortalBoomer()} className={cx(styles.menuNavItem, styles.menuNavItemBoomer)}>Boomer</button></li>
                }
            </ul>

            <div className={styles.menuNavExit}>
                {currentUser.isBoombassador && (<Link to='boombassador' className={cx(styles.menuNavItem, styles.menuNavItemBoombassador)}></Link>)}
                <LogoutButton onLogout={onLogout} classes={cx(styles.menuNavItem, styles.menuNavExitBtn)}>
                    Logout
                </LogoutButton>
            </div>
        </>
    )
}

export default NavLinks;

